import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {
  Observable,
  ReplaySubject
} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {CommissionTable} from '../../../../shared/interface/commission-table';
import {AuthService} from '../../../../shared/services/auth.service';
import {UserPermissions} from '../../../../shared/interface/user-permissions';

@Component({
  selector: 'app-commission-table-details-view',
  templateUrl: './commission-table-details-view.component.html',
  styleUrls: ['./commission-table-details-view.component.scss']
})
export class CommissionTableDetailsViewComponent
  implements OnInit, OnDestroy {

  @Input()
  commissionTable: Observable<CommissionTable>;

  @Output()
  modifyClicked = new EventEmitter<void>();

  commissionTableObject?: CommissionTable;

  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean>
    = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
  ) {
    this.userPermissions =
      this.auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.commissionTable
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe(
        (commissionTable: CommissionTable) => {
          this.commissionTableObject = commissionTable;
        }
      );
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }
}
